class DataListData {

    constructor() {

        this._BIG_HEADER_MODE = 1;
        this._SMALL_HEADER_MODE = 2;

        this._headerMode = this._BIG_HEADER_MODE;

    }

    getHeaderModes() {

        return {
            BIG_HEADER_MODE: this._BIG_HEADER_MODE,
            SMALL_HEADER_MODE: this._SMALL_HEADER_MODE
        };

    }

    getHeaderMode() {
        return this._headerMode;
    }

    setHeaderMode(headerMode) {
        this._headerMode = headerMode;
    }

}